import { render, staticRenderFns } from "./all-customer.vue?vue&type=template&id=ca34eb48&"
import script from "./all-customer.vue?vue&type=script&lang=js&"
export * from "./all-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports